import { EllipsisOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Modal, Table } from 'antd';
import classNames from 'classnames';
import DraggableRow from 'components/commons/DraggableRow';
import { getBriefTitle } from 'constants/brief.helpers';
import { ModalConfirm } from 'constants/Notifications';
import update from 'immutability-helper';
import { isEqual } from 'lodash';
import { useRouter } from 'next/router';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { ServiceBriefs } from 'services/ServiceBriefs';
import { Brief, viewmode } from 'store/types';
import { useStore } from 'store/zustandProvider';
import BriefListElement from './commons/BriefListElement';
import RowAvatarImage from './commons/ChannelImg';
import DragAndDrop from './commons/DragAndDrop';
import JsonLog from './commons/JsonLog';
import NoItems from './commons/NoItems';
import ShareComponent from './commons/ShareComponent';

const { confirm } = Modal;

interface BriefsListProps {
  briefs?: Brief[];
  channelUUID?: string;
  ViewMode?: viewmode;
  onAction?: Function;
  onClickedBrief?: Function;
}
const BriefsList: FC<BriefsListProps> = ({
  briefs = [],
  ViewMode = 'list',
  onAction,
  onClickedBrief,
  channelUUID
}) => {
  const [tableData, setTableData] = useState(briefs);

  const router = useRouter();
  const { me, setMe, ownChannel, isCoeditor, setPlaylist, playlist } = useStore();


  const canEditChannel = useMemo(() => {

    if (ownChannel) return true;
    else if (isCoeditor) return true;
    else return false;

  }, [ownChannel, isCoeditor]);

  useEffect(() => {
    if (!isEqual(briefs, tableData)) {
      console.log('Effect Briefs', briefs);
      setTableData(briefs);

    }

    setPlaylist(briefs.map(brief => brief.translations[0].audio));

    return () => {
      setPlaylist([]);
    };

  }, [briefs]);



  const goToBrief = (brief: Brief) => {
    debugger;
    if (onClickedBrief) onClickedBrief(brief);
  };

  const columns = useMemo(
    () => [
      ...(canEditChannel
        ? [
          {
            title: '',
            dataIndex: 'id',

            className: 'dragColumn',
            //responsive: ['lg'],
            render: () => (
              <div className="hoverRow">
                <img src="/drag.svg" />
              </div>
            )
          }
        ]
        : []),

      {
        className: ' imageColumn',
        key: 'image',

        render: (brief: Brief) => (
          <div onClick={() => goToBrief(brief)}>
            <RowAvatarImage brief={brief} />
          </div>
        )
      },

      {
        title: 'Title',
        className: 'textColumn',
        render: (brief: Brief) => (
          <BriefListElement brief={brief} onClicked={() => goToBrief(brief)} />
        )
      },

      ...(canEditChannel
        ? [
          {
            title: '',
            className: 'menuColumn  desktop',
            key: 'actions',
            render: (brief: Brief) => <div className="">{renderMenuItem(brief)}</div>
          }
        ]
        : [])
    ],
    [ownChannel, isCoeditor, canEditChannel]
  );

  const deleteBrief = async (brief: Brief) => {
    ModalConfirm({
      title: 'Are you sure delete this Brief?',
      content: `Delete Brief : ${getBriefTitle(brief)} ?`,
      okText: 'Delete'
    }).then((confirmed) => {
      if (confirmed) {
        console.log('OK');
        ServiceBriefs.delete({ briefUUID: brief.uuid }).then((response) => {
          onAction && onAction();
        });
      }
    });
  };

  const editBrief = async (brief: Brief) => {
    debugger;
    router.push({
      pathname: `/briefs/${brief.uuid}`
    });
  };

  const linkBrief = (brief: Brief) => {
    window.open(brief.content.link, 'blank');
  };

  const renderMenuItem = (brief: Brief) => {
    if (canEditChannel) {
      return (
        <Dropdown
          className="actionsMenu"
          placement="topCenter"
          overlay={
            <Menu className="actionsMenu">

              <Menu.Item key="0">
                <Button type="link" className="linkBtn" onClick={() => deleteBrief(brief)}>
                  Delete
                </Button>
              </Menu.Item>

              <Menu.Item key="1">
                <ShareComponent channelUUID={channelUUID} brief={brief}>
                  <Button type="link" className="linkBtn">
                    Share
                  </Button>
                </ShareComponent>
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item key="3">
                <Button type="link" className="linkBtn" onClick={() => editBrief(brief)}>
                  Edit
                </Button>
              </Menu.Item>
            </Menu>
          }
          trigger={['click']}>
          <EllipsisOutlined />
        </Dropdown>
      );
    } else {
      return (
        <Dropdown
          className="actionsMenu"
          placement="topCenter"
          overlay={
            <Menu className="actionsMenu">
              <Menu.Item key="share">
                <ShareComponent channelUUID={channelUUID} brief={brief}>
                  <Button type="link" className="linkBtn">
                    Share
                  </Button>
                </ShareComponent>
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item key="link">
                <Button type="link" className="linkBtn" onClick={() => linkBrief(brief)}>
                  Link
                </Button>
              </Menu.Item>
            </Menu>
          }
          trigger={['click']}>
          <EllipsisOutlined />
        </Dropdown>
      );
    }
  };
  const moveDraggable = (dragIndex, hoverIndex) => {
    console.log('moveRow -> dragIndex', dragIndex, hoverIndex);

    const dragRow: Brief = tableData[dragIndex];
    //debugger;
    setTableData((tableData) =>
      update(tableData, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow]
        ]
      })
    );

    ServiceBriefs.order({
      briefUUID: dragRow?.uuid!,
      position: hoverIndex + 1
    });
  };




  if (!tableData.length) return <NoItems />;
  return (
    <React.Fragment>
      <div id="TableListWrapper">
        <DragAndDrop>
          <Table
            id="BriefsList"
            className={classNames({ ownChannel: canEditChannel, publicChannel: !canEditChannel })}
            dataSource={tableData}
            pagination={false}
            rowKey="uuid"
            //@ts-ignore
            columns={columns}
            components={{
              body: {
                row: DraggableRow
              }
            }}
            //@ts-ignore
            onRow={(record, index) => ({
              index,
              moveRow: canEditChannel ? moveDraggable : null
            })}
          />
        </DragAndDrop>
      </div>
      <JsonLog src={{ playlist, isCoeditor, ownChannel, canEditChannel }} />
    </React.Fragment>
  );
};
export default BriefsList;
